var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"BackButton btn btn-secondary",on:{"click":function($event){return _vm.goBack()}}},[_c('i',{staticClass:"fa fa-angle-double-left mr-1"}),_vm._v("\n  "+_vm._s(_vm.$t("global.go_back"))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }